export default {
  abw: "Aruba",
  afg: "Afghanistan",
  ago: "Angola",
  aia: "Anguilla",
  ala: "Åland Islands",
  alb: "Albania",
  and: "Andorra",
  are: "United Arab Emirates (the)",
  arg: "Argentina",
  arm: "Armenia",
  asm: "American Samoa",
  ata: "Antarctica",
  atf: "French Southern Territories (the)",
  atg: "Antigua and Barbuda",
  aus: "Australia",
  aut: "Austria",
  aze: "Azerbaijan",
  bdi: "Burundi",
  bel: "Belgium",
  ben: "Benin",
  bes: "Bonaire, Sint Eustatius and Saba",
  bfa: "Burkina Faso",
  bgd: "Bangladesh",
  bgr: "Bulgaria",
  bhr: "Bahrain",
  bhs: "Bahamas (the)",
  bih: "Bosnia and Herzegovina",
  blm: "Saint Barthélemy",
  blr: "Belarus",
  blz: "Belize",
  bmu: "Bermuda",
  bol: "Bolivia (Plurinational State of)",
  bra: "Brazil",
  brb: "Barbados",
  brn: "Brunei Darussalam",
  btn: "Bhutan",
  bvt: "Bouvet Island",
  bwa: "Botswana",
  caf: "Central African Republic (the)",
  can: "Canada",
  cck: "Cocos (Keeling) Islands (the)",
  che: "Switzerland",
  chl: "Chile",
  chn: "China",
  civ: "Côte d'Ivoire",
  cmr: "Cameroon",
  cod: "Congo (the Democratic Republic of the)",
  cog: "Congo (the)",
  cok: "Cook Islands (the)",
  col: "Colombia",
  com: "Comoros (the)",
  cpv: "Cabo Verde",
  cri: "Costa Rica",
  cub: "Cuba",
  cuw: "Curaçao",
  cxr: "Christmas Island",
  cym: "Cayman Islands (the)",
  cyp: "Cyprus",
  cze: "Czechia",
  deu: "Germany",
  dji: "Djibouti",
  dma: "Dominica",
  dnk: "Denmark",
  dom: "Dominican Republic (the)",
  dza: "Algeria",
  ecu: "Ecuador",
  egy: "Egypt",
  eri: "Eritrea",
  esh: "Western Sahara*",
  esp: "Spain",
  est: "Estonia",
  eth: "Ethiopia",
  fin: "Finland",
  fji: "Fiji",
  flk: "Falkland Islands (the) [Malvinas]",
  fra: "France",
  fro: "Faroe Islands (the)",
  fsm: "Micronesia (Federated States of)",
  gab: "Gabon",
  gbr: "United Kingdom of Great Britain and Northern Ireland (the)",
  geo: "Georgia",
  ggy: "Guernsey",
  gha: "Ghana",
  gib: "Gibraltar",
  gin: "Guinea",
  glp: "Guadeloupe",
  gmb: "Gambia (the)",
  gnb: "Guinea-Bissau",
  gnq: "Equatorial Guinea",
  grc: "Greece",
  grd: "Grenada",
  grl: "Greenland",
  gtm: "Guatemala",
  guf: "French Guiana",
  gum: "Guam",
  guy: "Guyana",
  hkg: "Hong Kong",
  hmd: "Heard Island and McDonald Islands",
  hnd: "Honduras",
  hrv: "Croatia",
  hti: "Haiti",
  hun: "Hungary",
  idn: "Indonesia",
  imn: "Isle of Man",
  ind: "India",
  iot: "British Indian Ocean Territory (the)",
  irl: "Ireland",
  irn: "Iran (Islamic Republic of)",
  irq: "Iraq",
  isl: "Iceland",
  isr: "Israel",
  ita: "Italy",
  jam: "Jamaica",
  jey: "Jersey",
  jor: "Jordan",
  jpn: "Japan",
  kaz: "Kazakhstan",
  ken: "Kenya",
  kgz: "Kyrgyzstan",
  khm: "Cambodia",
  kir: "Kiribati",
  kna: "Saint Kitts and Nevis",
  kor: "Korea (the Republic of)",
  kwt: "Kuwait",
  lao: "Lao People's Democratic Republic (the)",
  lbn: "Lebanon",
  lbr: "Liberia",
  lby: "Libya",
  lca: "Saint Lucia",
  lie: "Liechtenstein",
  lka: "Sri Lanka",
  lso: "Lesotho",
  ltu: "Lithuania",
  lux: "Luxembourg",
  lva: "Latvia",
  mac: "Macao",
  maf: "Saint Martin (French part)",
  mar: "Morocco",
  mco: "Monaco",
  mda: "Moldova (the Republic of)",
  mdg: "Madagascar",
  mdv: "Maldives",
  mex: "Mexico",
  mhl: "Marshall Islands (the)",
  mkd: "Macedonia (the former Yugoslav Republic of)",
  mli: "Mali",
  mlt: "Malta",
  mmr: "Myanmar",
  mne: "Montenegro",
  mng: "Mongolia",
  mnp: "Northern Mariana Islands (the)",
  moz: "Mozambique",
  mrt: "Mauritania",
  msr: "Montserrat",
  mtq: "Martinique",
  mus: "Mauritius",
  mwi: "Malawi",
  mys: "Malaysia",
  myt: "Mayotte",
  nam: "Namibia",
  ncl: "New Caledonia",
  ner: "Niger (the)",
  nfk: "Norfolk Island",
  nga: "Nigeria",
  nic: "Nicaragua",
  niu: "Niue",
  nld: "Netherlands (the)",
  nor: "Norway",
  npl: "Nepal",
  nru: "Nauru",
  nzl: "New Zealand",
  omn: "Oman",
  pak: "Pakistan",
  pan: "Panama",
  pcn: "Pitcairn",
  per: "Peru",
  phl: "Philippines (the)",
  plw: "Palau",
  png: "Papua New Guinea",
  pol: "Poland",
  pri: "Puerto Rico",
  prk: "Korea (the Democratic People's Republic of)",
  prt: "Portugal",
  pry: "Paraguay",
  pse: "Palestine, State of",
  pyf: "French Polynesia",
  qat: "Qatar",
  reu: "Réunion",
  rou: "Romania",
  rus: "Russian Federation (the)",
  rwa: "Rwanda",
  sau: "Saudi Arabia",
  sdn: "Sudan (the)",
  sen: "Senegal",
  sgp: "Singapore",
  sgs: "South Georgia and the South Sandwich Islands",
  shn: "Saint Helena, Ascension and Tristan da Cunha",
  sjm: "Svalbard and Jan Mayen",
  slb: "Solomon Islands",
  sle: "Sierra Leone",
  slv: "El Salvador",
  smr: "San Marino",
  som: "Somalia",
  spm: "Saint Pierre and Miquelon",
  srb: "Serbia",
  ssd: "South Sudan",
  stp: "Sao Tome and Principe",
  sur: "Suriname",
  svk: "Slovakia",
  svn: "Slovenia",
  swe: "Sweden",
  swz: "Swaziland",
  sxm: "Sint Maarten (Dutch part)",
  syc: "Seychelles",
  syr: "Syrian Arab Republic",
  tca: "Turks and Caicos Islands (the)",
  tcd: "Chad",
  tgo: "Togo",
  tha: "Thailand",
  tjk: "Tajikistan",
  tkl: "Tokelau",
  tkm: "Turkmenistan",
  tls: "Timor-Leste",
  ton: "Tonga",
  tto: "Trinidad and Tobago",
  tun: "Tunisia",
  tur: "Turkey",
  tuv: "Tuvalu",
  twn: "Taiwan (Province of China)",
  tza: "Tanzania, United Republic of",
  uga: "Uganda",
  ukr: "Ukraine",
  umi: "United States Minor Outlying Islands (the)",
  ury: "Uruguay",
  usa: "United States of America (the)",
  uzb: "Uzbekistan",
  vat: "Holy See (the)",
  vct: "Saint Vincent and the Grenadines",
  ven: "Venezuela (Bolivarian Republic of)",
  vgb: "Virgin Islands (British)",
  vir: "Virgin Islands (U.S.)",
  vnm: "Viet Nam",
  vut: "Vanuatu",
  wlf: "Wallis and Futuna",
  wsm: "Samoa",
  yem: "Yemen",
  zaf: "South Africa",
  zmb: "Zambia",
  zwe: "Zimbabwe",
  zzz: "Others"
}